import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './header.component';
import {ButtonModule} from "@xref/xref-lib";
import { TranslationSelectorModule } from '@xref/ngx';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        TranslationSelectorModule,
        CommonModule,
        ButtonModule,

    ],
    exports: [HeaderComponent]
})
export class HeaderModule {
}
